export default __webpack_public_path__ + "static/media/Logomarca_Cento_Britanico_bco hor.38b88b92.png";